import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module,
	DateUtils
} from 'ps-gui';

import {
	CellMainText,
	CellSubText
} from '../portalresultsetmodule';

import AffirmationSubmissionSettingsModel from './affirmationsubmissionsettingsmodel';

const Wrapper = styled.div`
	.ps-moduleContainerContent {
		overflow: visible !important;
	}

	.ps-tabPaneContent {
		overflow: visible !important;
		padding-top: 24px;
	}
`;

export default class AffirmationSubmissionSettingsModule extends ParentBoundComponent {

	getModel() {
		return new AffirmationSubmissionSettingsModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}

	render() {
		const data = this.getData();
		return (
			<Wrapper>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={customResultProps}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'submission_date_range': (cell, row, colIndex) => {
		const fromDate = row.get('submission_from_date');
		const toDate = row.get('submission_to_date');
		if (!fromDate && !toDate) {
			return null;
		}
		return (
			<>
				<CellMainText>{DateUtils.formatDate(fromDate) + ' - ' + DateUtils.formatDate(toDate)}</CellMainText>
			</>
		);
	},
	'created_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('created_by')}</CellSubText>
			</>
		);
	},
	'edited_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('edited_by')}</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: false,
	withRowSelection: true,
	defaultColumnWidths: {
		'country': '100px',
		'attendance': '110px',
		'release_date': '110px'
	},
	columnFilters: {
	}
};

